module.exports = __webpack_public_path__ + "img/136.d7eaa93d.jpg";